// import React, { useEffect, useState } from "react";
// import {
//   Table, Button, Tag, Card, Layout,
//   Typography, Space, message
// } from "antd";
// import { MailOutlined, MenuOutlined } from "@ant-design/icons";
// import axios from "axios";
// import { BASE_URL } from "../../Config";
// import Sidebar from "../../Components/Sidebar";

// const { Header } = Layout;
// const { Text } = Typography;

// const ExpiryReport = () => {
//   const [data, setData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [sendingEmail, setSendingEmail] = useState(null);
//   const [collapsed, setCollapsed] = useState(false);
//   const [isMobile, setIsMobile] = useState(false);
//   const [mobileOpen, setMobileOpen] = useState(false);
//   const [filter, setFilter] = useState("expiring");

//   const token = sessionStorage.getItem("token");

//   useEffect(() => {
//     const check = () => setIsMobile(window.innerWidth <= 768);
//     check();
//     window.addEventListener("resize", check);
//     return () => window.removeEventListener("resize", check);
//   }, []);

//   useEffect(() => {
//     fetchExpiringUsers(filter);
//   }, [filter]);

//   const fetchExpiringUsers = async (selectedFilter = filter) => {
//     try {
//       setLoading(true);
//       const url = selectedFilter === "expired"
//         ? `${BASE_URL}/dashboard/expiring?type=expired`
//         : `${BASE_URL}/dashboard/expiring`;
//       const res = await axios.get(url, {
//         headers: { Authorization: `Bearer ${token}` },
//       });
//       setData(res.data.data || []);
//     } catch {
//       message.error("Failed to load expiry report");
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleSendReminder = async (record) => {
//     try {
//       setSendingEmail(record._id);
//       await axios.post(
//         `${BASE_URL}/dashboard/send-reminder`,
//         {
//           userId: record._id,
//           email: record.userEmail,
//           name: record.userName,
//         },
//         { headers: { Authorization: `Bearer ${token}` } }
//       );
//       message.success(`Reminder sent to ${record.userEmail}`);
//     } catch {
//       message.error("Failed to send reminder");
//     } finally {
//       setSendingEmail(null);
//     }
//   };

//   const handleExportCSV = () => {
//     const headers = ["Name", "Email", "Plan", "Days Remaining", "Image Count", "Expiry Date"];
//     const rows = data.map((r) => [
//       r.userName,
//       r.userEmail,
//       r.activePlan || "free",
//       r.daysRemaining ?? "expired",
//       r.imageCount,
//       new Date(r.mediaLinkExpiryDate).toLocaleDateString(),
//     ]);

//     const csv = [headers, ...rows].map((r) => r.join(",")).join("\n");
//     const blob = new Blob([csv], { type: "text/csv" });
//     const url = URL.createObjectURL(blob);
//     const a = document.createElement("a");
//     a.href = url;
//     a.download = "expiry_report.csv";
//     a.click();
//   };

//   const columns = [
//     {
//       title: "User",
//       render: (_, r) => (
//         <>
//           <div><strong>{r.userName}</strong></div>
//           <small style={{ color: "#888" }}>{r.userEmail}</small>
//         </>
//       ),
//     },
//     {
//       title: "Plan",
//       dataIndex: "activePlan",
//       render: (plan) => (
//         <Tag color="purple">{plan || "free"}</Tag>
//       ),
//       filters: [
//         { text: "Basic-1", value: "basic-1" },
//         { text: "Basic-2", value: "basic-2" },
//         { text: "Standard", value: "standard" },
//         { text: "Premium", value: "premium" },
//         { text: "Free", value: null },
//       ],
//       onFilter: (value, record) => record.activePlan === value,
//     },
//     {
//       title: "Days Remaining",
//       dataIndex: "daysRemaining",
//       sorter: (a, b) => (a.daysRemaining ?? -1) - (b.daysRemaining ?? -1),
//       render: (days) =>
//         days != null ? (
//           <Tag color={days <= 7 ? "red" : days <= 15 ? "orange" : "green"}>
//             {days} days
//           </Tag>
//         ) : (
//           <Tag color="red">Expired</Tag>
//         ),
//     },
//     {
//       title: "Image Count",
//       dataIndex: "imageCount",
//       sorter: (a, b) => a.imageCount - b.imageCount,
//     },
//     {
//       title: "Expiry Date",
//       dataIndex: "mediaLinkExpiryDate",
//       render: (date) => new Date(date).toLocaleDateString(),
//       sorter: (a, b) =>
//         new Date(a.mediaLinkExpiryDate) - new Date(b.mediaLinkExpiryDate),
//     },
//     {
//       title: "Reminder",
//       render: (_, record) => (
//         <Button
//           icon={<MailOutlined />}
//           loading={sendingEmail === record._id}
//           onClick={() => handleSendReminder(record)}
//         >
//           Send Email
//         </Button>
//       ),
//     },
//   ];

//   return (
//     <Layout style={{ minHeight: "100vh", background: "#f5f7fa" }}>
//       <Sidebar
//         collapsed={collapsed}
//         setCollapsed={setCollapsed}
//         mobileOpen={mobileOpen}
//         setMobileOpen={setMobileOpen}
//         isMobile={isMobile}
//         collapsedWidth="0"
//         role="admin"
//       />
//       <Layout
//         className="main-layout"
//         style={{
//           marginLeft: isMobile ? 0 : collapsed ? 0 : 240,
//           transition: "0.3s",
//           padding: isMobile ? 10 : 20,
//         }}
//       >
//         <Header className="MainHeader">
//           {isMobile && (
//             <Button
//               type="text"
//               icon={<MenuOutlined />}
//               onClick={() => setMobileOpen(true)}
//               style={{ fontSize: 18, marginRight: 12 }}
//             />
//           )}
//           <div style={{ flex: 1 }}>
//             <Text style={{ fontSize: 20, fontWeight: "bold" }}>
//               Expiring Extensions
//             </Text>
//           </div>
//           <Space style={{ marginRight: 12 }}>
//             <Button
//               type={filter === "expiring" ? "primary" : "default"}
//               onClick={() => setFilter("expiring")}
//             >
//               Expiring Soon
//             </Button>
//             <Button
//               type={filter === "expired" ? "primary" : "default"}
//               danger={filter === "expired"}
//               onClick={() => setFilter("expired")}
//             >
//               Already Expired
//             </Button>
//           </Space>
//           <Button
//             type="primary"
//             onClick={handleExportCSV}
//             style={{ background: "#10b981", borderColor: "#10b981" }}
//           >
//             Export CSV
//           </Button>
//         </Header>

//         <Card style={{ borderRadius: 12 }}>
//           <Table
//             columns={columns}
//             dataSource={data}
//             rowKey="_id"
//             loading={loading}
//             pagination={{ pageSize: 10 }}
//           />
//         </Card>
//       </Layout>
//     </Layout>
//   );
// };

// export default ExpiryReport;

import React, { useEffect, useState } from "react";
import {
  Table, Button, Tag, Card, Layout,
  Typography, Space, message, Drawer, Divider
} from "antd";
import { MailOutlined, MenuOutlined, DownloadOutlined, ClockCircleOutlined, WarningOutlined } from "@ant-design/icons";
import axios from "axios";
import { BASE_URL } from "../../Config";
import Sidebar from "../../Components/Sidebar";

const { Header, Content } = Layout;
const { Text, Title } = Typography;

const ExpiryReport = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [sendingEmail, setSendingEmail] = useState(null);
  const [collapsed, setCollapsed] = useState(false);
  const [isMobile, setIsMobile] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [filter, setFilter] = useState("expiring");

  const token = sessionStorage.getItem("token");

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth <= 768);
    check();
    window.addEventListener("resize", check);
    return () => window.removeEventListener("resize", check);
  }, []);

  useEffect(() => {
    fetchExpiringUsers(filter);
  }, [filter]);

  const fetchExpiringUsers = async (selectedFilter = filter) => {
    try {
      setLoading(true);
      const url =
        selectedFilter === "expired"
          ? `${BASE_URL}/dashboard/expiring?type=expired`
          : `${BASE_URL}/dashboard/expiring`;
      const res = await axios.get(url, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setData(res.data.data || []);
    } catch {
      message.error("Failed to load expiry report");
    } finally {
      setLoading(false);
    }
  };

  const handleSendReminder = async (record) => {
    try {
      setSendingEmail(record._id);
      await axios.post(
        `${BASE_URL}/dashboard/send-reminder`,
        { userId: record._id, email: record.userEmail, name: record.userName },
        { headers: { Authorization: `Bearer ${token}` } }
      );
      message.success(`Reminder sent to ${record.userEmail}`);
    } catch {
      message.error("Failed to send reminder");
    } finally {
      setSendingEmail(null);
    }
  };

  const handleExportCSV = () => {
    const headers = ["Name", "Email", "Plan", "Days Remaining", "Image Count", "Expiry Date"];
   const escape = (val) => `"${String(val ?? "").replace(/"/g, '""')}"`;
const rows = data.map((r) => [
  escape(r.userName),
  escape(r.userEmail),
  escape(r.activePlan || "free"),
  escape(r.daysRemaining ?? "expired"),
  escape(r.imageCount),
  escape(new Date(r.mediaLinkExpiryDate).toLocaleDateString()),
]);
const csv = [headers.map(escape), ...rows].map((r) => r.join(",")).join("\n");
    const blob = new Blob([csv], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = "expiry_report.csv";
    a.click();
  };

  const getDaysTag = (days) => {
    if (days == null) return <Tag color="red">Expired</Tag>;
    if (days <= 7) return <Tag color="red">{days} days</Tag>;
    if (days <= 15) return <Tag color="orange">{days} days</Tag>;
    return <Tag color="green">{days} days</Tag>;
  };

  // ── Desktop table columns ────────────────────────────────────────────────
  const columns = [
    {
      title: "User",
      render: (_, r) => (
        <>
          <div><strong>{r.userName}</strong></div>
          <small style={{ color: "#888" }}>{r.userEmail}</small>
        </>
      ),
    },
    {
      title: "Plan",
      dataIndex: "activePlan",
      render: (plan) => <Tag color="purple">{plan || "free"}</Tag>,
      filters: [
        { text: "Basic-1", value: "basic-1" },
        { text: "Basic-2", value: "basic-2" },
        { text: "Standard", value: "standard" },
        { text: "Premium", value: "premium" },
        { text: "Free", value: null },
      ],
      onFilter: (value, record) => record.activePlan === value,
    },
    {
      title: "Days Remaining",
      dataIndex: "daysRemaining",
      sorter: (a, b) => (a.daysRemaining ?? -1) - (b.daysRemaining ?? -1),
      render: (days) => getDaysTag(days),
    },
    {
      title: "Image Count",
      dataIndex: "imageCount",
      sorter: (a, b) => a.imageCount - b.imageCount,
    },
    {
      title: "Expiry Date",
      dataIndex: "mediaLinkExpiryDate",
      render: (date) => new Date(date).toLocaleDateString(),
      sorter: (a, b) =>
        new Date(a.mediaLinkExpiryDate) - new Date(b.mediaLinkExpiryDate),
    },
    {
      title: "Reminder",
      render: (_, record) => (
        <Button
          icon={<MailOutlined />}
          loading={sendingEmail === record._id}
          onClick={() => handleSendReminder(record)}
        >
          Send Email
        </Button>
      ),
    },
  ];

  // ── Mobile card list ─────────────────────────────────────────────────────
  const MobileCard = ({ record }) => (
    <Card
      style={{
        marginBottom: 12,
        borderRadius: 12,
        boxShadow: "0 1px 6px rgba(0,0,0,0.08)",
      }}
      bodyStyle={{ padding: "14px 16px" }}
    >
      {/* Row 1 – Name + Plan */}
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 8 }}>
        <div style={{ flex: 1, minWidth: 0, paddingRight: 8 }}>
          <Text strong style={{ fontSize: 15, display: "block", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
            {record.userName}
          </Text>
          <Text type="secondary" style={{ fontSize: 12, display: "block", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
            {record.userEmail}
          </Text>
        </div>
        <Tag color="purple" style={{ flexShrink: 0 }}>{record.activePlan || "free"}</Tag>
      </div>

      <Divider style={{ margin: "8px 0" }} />

      {/* Row 2 – Stats */}
      <div style={{ display: "flex", gap: 8, flexWrap: "wrap", marginBottom: 10 }}>
        <div style={statBox}>
          <Text type="secondary" style={{ fontSize: 11 }}>Days Left</Text>
          <div style={{ marginTop: 2 }}>{getDaysTag(record.daysRemaining)}</div>
        </div>
        <div style={statBox}>
          <Text type="secondary" style={{ fontSize: 11 }}>Images</Text>
          <Text strong style={{ display: "block", marginTop: 2 }}>{record.imageCount}</Text>
        </div>
        <div style={statBox}>
          <Text type="secondary" style={{ fontSize: 11 }}>Expires</Text>
          <Text style={{ display: "block", fontSize: 13, marginTop: 2 }}>
            {new Date(record.mediaLinkExpiryDate).toLocaleDateString()}
          </Text>
        </div>
      </div>

      {/* Row 3 – Action */}
      <Button
        block
        icon={<MailOutlined />}
        loading={sendingEmail === record._id}
        onClick={() => handleSendReminder(record)}
      >
        Send Reminder
      </Button>
    </Card>
  );

  const statBox = {
    flex: "1 1 80px",
    background: "#f9fafb",
    borderRadius: 8,
    padding: "6px 10px",
  };

  // ── Layout ───────────────────────────────────────────────────────────────
  const sidebarWidth = isMobile ? 0 : collapsed ? 0 : 240;

  return (
    <Layout style={{ minHeight: "100vh", background: "#f5f7fa" }}>
      <Sidebar
        collapsed={collapsed}
        setCollapsed={setCollapsed}
        mobileOpen={mobileOpen}
        setMobileOpen={setMobileOpen}
        isMobile={isMobile}
        collapsedWidth="0"
        role="admin"
      />

      <Layout
        style={{
          marginLeft: sidebarWidth,
          transition: "margin-left 0.3s",
        }}
      >
        {/* ── Header ── */}
        <Header
          style={{
            background: "#fff",
            padding: isMobile ? "0 12px" : "0 24px",
            height: "auto",
            minHeight: 64,
            display: "flex",
            alignItems: "center",
            flexWrap: "wrap",
            gap: 8,
            borderBottom: "1px solid #f0f0f0",
            position: "sticky",
            top: 0,
            zIndex: 100,
            boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
          }}
        >
          {/* Hamburger + Title */}
          <div style={{ display: "flex", alignItems: "center", gap: 10, flex: "1 1 auto", minWidth: 0 }}>
            {isMobile && (
              <Button
                type="text"
                icon={<MenuOutlined />}
                onClick={() => setMobileOpen(true)}
                style={{ fontSize: 18, padding: 0 }}
              />
            )}
            <Text
              strong
              style={{
                fontSize: isMobile ? 16 : 20,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              Expiring Extensions
            </Text>
          </div>

          {/* Controls row – wraps on mobile */}
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: 8,
              flexWrap: "wrap",
              width: isMobile ? "100%" : "auto",
              paddingBottom: isMobile ? 8 : 0,
            }}
          >
            <Button
              type={filter === "expiring" ? "primary" : "default"}
              icon={<ClockCircleOutlined />}
              onClick={() => setFilter("expiring")}
              style={{ flex: isMobile ? "1 1 0" : "none" }}
            >
              Expiring Soon
            </Button>
            <Button
              type={filter === "expired" ? "primary" : "default"}
              danger={filter === "expired"}
              icon={<WarningOutlined />}
              onClick={() => setFilter("expired")}
              style={{ flex: isMobile ? "1 1 0" : "none" }}
            >
              Expired
            </Button>
            <Button
              icon={<DownloadOutlined />}
              onClick={handleExportCSV}
              style={{
                background: "#10b981",
                borderColor: "#10b981",
                color: "#fff",
                flex: isMobile ? "1 1 100%" : "none",
              }}
            >
              Export CSV
            </Button>
          </div>
        </Header>

        {/* ── Content ── */}
        <Content style={{ padding: isMobile ? "12px 10px" : "20px 24px" }}>
          {isMobile ? (
            /* Mobile: card list */
            loading ? (
              <div style={{ textAlign: "center", padding: 40 }}>
                <Text type="secondary">Loading…</Text>
              </div>
            ) : data.length === 0 ? (
              <Card style={{ borderRadius: 12, textAlign: "center" }}>
                <Text type="secondary">No records found.</Text>
              </Card>
            ) : (
              data.map((record) => (
                <MobileCard key={record._id} record={record} />
              ))
            )
          ) : (
            /* Desktop: table */
            <Card style={{ borderRadius: 12 }}>
              <Table
                columns={columns}
                dataSource={data}
                rowKey="_id"
                loading={loading}
                pagination={{ pageSize: 10 }}
                scroll={{ x: true }}
              />
            </Card>
          )}
        </Content>
      </Layout>
    </Layout>
  );
};

export default ExpiryReport;